import { CampaignEditorBody } from 'lib.store/src/type-partner/campaigns/models';
import { ReactNode } from 'react';
import { toApiDate } from 'lib.shared/src/utils';

export const campaignInitialForm: CampaignEditorBody = {
  event_id: '',
  campaign_id: '',
  landing: null,
  title: 'New campaign',
  conversions: [],
  audiences: null,
  goal: null,
  schedule: {
    started_at: toApiDate(new Date()),
    finished_at: '',
  },
};

export const BUSINESS_NAME_MAX_COUNT = 25;
export const TITLE_MAX_COUNT = 90;
export const SHORT_TITLE_MAX_COUNT = 30;
export const DESCRIPTION_MAX_COUNT = 90;

export enum CampaignTabs {
  CampaignSettings = 'campaign-settings',
  Groups = 'groups',
  Creatives = 'creatives',
}

/** @deprecated Use AdFormats instead */
export enum CreativeTypes {
  SingleImage = '100',
  Carousel = '101',
  Video = '102',
}

export enum AdFormats {
  SingleImage = 'single_image',
  Carousel = 'carousel',
  Video = 'video',
  Banner = 'banner',
  ResponsiveDisplay = 'responsive_display',
}

export enum CreativesTypes {
  SingleImage = 'linkedin_single_image',
  Carousel = 'linkedin_carousel',
  Video = 'linkedin_video',
}

/** AdDestination enum names — where a click on a group's creatives lands */
export enum AdDestinations {
  LandingPage = 'landing_page',
  LeadForm = 'lead_form',
}

export const creativesTypesIcons: Record<string, ReactNode> = {
  [AdFormats.SingleImage]: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#clip0_2024_24316)">
        <path
          d="M15.4286 1.71106H0.571429C0.255357 1.71106 0 1.96642 0 2.28249V13.7111C0 14.0271 0.255357 14.2825 0.571429 14.2825H15.4286C15.7446 14.2825 16 14.0271 16 13.7111V2.28249C16 1.96642 15.7446 1.71106 15.4286 1.71106ZM14.7143 12.9968H1.28571V12.2843L3.75893 9.35035L6.43929 12.5289L10.6089 7.58606L14.7143 12.4539V12.9968ZM14.7143 10.6789L10.7179 5.93963C10.6607 5.87177 10.5571 5.87177 10.5 5.93963L6.43929 10.7539L3.86786 7.7057C3.81071 7.63785 3.70714 7.63785 3.65 7.7057L1.28571 10.5093V2.99677H14.7143V10.6789ZM4.28571 6.99677C4.49208 6.99677 4.69642 6.95613 4.88707 6.87716C5.07773 6.79818 5.25096 6.68243 5.39688 6.53651C5.5428 6.39059 5.65855 6.21736 5.73752 6.02671C5.8165 5.83605 5.85714 5.63171 5.85714 5.42535C5.85714 5.21898 5.8165 5.01464 5.73752 4.82399C5.65855 4.63333 5.5428 4.4601 5.39688 4.31418C5.25096 4.16826 5.07773 4.05251 4.88707 3.97354C4.69642 3.89456 4.49208 3.85392 4.28571 3.85392C3.86895 3.85392 3.46925 4.01948 3.17455 4.31418C2.87985 4.60888 2.71429 5.00858 2.71429 5.42535C2.71429 5.84211 2.87985 6.24181 3.17455 6.53651C3.46925 6.83121 3.86895 6.99677 4.28571 6.99677ZM4.28571 4.92535C4.5625 4.92535 4.78571 5.14856 4.78571 5.42535C4.78571 5.70213 4.5625 5.92535 4.28571 5.92535C4.00893 5.92535 3.78571 5.70213 3.78571 5.42535C3.78571 5.14856 4.00893 4.92535 4.28571 4.92535Z"
          fill="#898A8C"
        />
      </g>
      <defs>
        <clipPath id="clip0_2024_24316">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  [AdFormats.Carousel]: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#clip0_2024_24330)">
        <path
          d="M6.92857 2.00059L-8.42857 2C-8.74464 2 -9 2.25536 -9 2.57143V14C-9 14.3161 -8.74464 14.5714 -8.42857 14.5714L6.92857 14.572C7.24464 14.572 7.5 14.3167 7.5 14.0006V2.57202C7.5 2.25594 7.24464 2.00059 6.92857 2.00059ZM6.21429 13.2863L-7.71429 13.2857V12.5732L-5.24107 9.63929L-2.56071 12.8179L2.10893 7.87559L6.21429 12.7434V13.2863ZM6.21429 10.9684L2.21786 6.22916C2.16072 6.1613 2.05714 6.1613 2 6.22916L-2.56071 11.0429L-5.13214 7.99464C-5.18929 7.92679 -5.29286 7.92679 -5.35 7.99464L-7.71429 10.7982V3.28571L6.21429 3.2863V10.9684ZM-4.71429 7.28572C-4.50792 7.28572 -4.30358 7.24507 -4.11293 7.1661C-3.92227 7.08713 -3.74904 6.97137 -3.60312 6.82545C-3.4572 6.67953 -3.34145 6.5063 -3.26248 6.31565C-3.1835 6.12499 -3.14286 5.92065 -3.14286 5.71429C-3.14286 5.50792 -3.1835 5.30358 -3.26248 5.11293C-3.34145 4.92227 -3.4572 4.74904 -3.60312 4.60312C-3.74904 4.4572 -3.92227 4.34145 -4.11293 4.26248C-4.30358 4.1835 -4.50792 4.14286 -4.71429 4.14286C-5.13105 4.14286 -5.53075 4.30842 -5.82545 4.60312C-6.12015 4.89782 -6.28571 5.29752 -6.28571 5.71429C-6.28571 6.13106 -6.12015 6.53075 -5.82545 6.82545C-5.53075 7.12015 -5.13105 7.28572 -4.71429 7.28572ZM-4.71429 5.21429C-4.4375 5.21429 -4.21429 5.4375 -4.21429 5.71429C-4.21429 5.99107 -4.4375 6.21429 -4.71429 6.21429C-4.99107 6.21429 -5.21429 5.99107 -5.21429 5.71429C-5.21429 5.4375 -4.99107 5.21429 -4.71429 5.21429Z"
          fill="#898A8C"
        />
        <path
          d="M25.4285 2H10.0714C9.75536 2 9.5 2.25536 9.5 2.57143V14C9.5 14.3161 9.75536 14.5714 10.0714 14.5714H25.4285C25.7446 14.5714 25.9999 14.3161 25.9999 14V2.57143C25.9999 2.25536 25.7446 2 25.4285 2ZM24.7142 13.2857H10.7857V12.5732L13.2589 9.63929L15.9393 12.8179L20.6089 7.875L24.7142 12.7429V13.2857ZM24.7142 10.9679L20.7178 6.22857C20.6607 6.16071 20.5571 6.16071 20.4999 6.22857L15.9393 11.0429L13.3679 7.99464C13.3107 7.92679 13.2071 7.92679 13.15 7.99464L10.7857 10.7982V3.28571H24.7142V10.9679ZM15.7857 7.28572C15.9921 7.28572 16.1964 7.24507 16.3871 7.1661C16.5777 7.08713 16.751 6.97137 16.8969 6.82545C17.0428 6.67953 17.1586 6.5063 17.2375 6.31565C17.3165 6.12499 17.3571 5.92065 17.3571 5.71429C17.3571 5.50792 17.3165 5.30358 17.2375 5.11293C17.1586 4.92227 17.0428 4.74904 16.8969 4.60312C16.751 4.4572 16.5777 4.34145 16.3871 4.26248C16.1964 4.1835 15.9921 4.14286 15.7857 4.14286C15.3689 4.14286 14.9692 4.30842 14.6745 4.60312C14.3798 4.89782 14.2143 5.29752 14.2143 5.71429C14.2143 6.13106 14.3798 6.53075 14.6745 6.82545C14.9692 7.12015 15.3689 7.28572 15.7857 7.28572ZM15.7857 5.21429C16.0625 5.21429 16.2857 5.4375 16.2857 5.71429C16.2857 5.99107 16.0625 6.21429 15.7857 6.21429C15.5089 6.21429 15.2857 5.99107 15.2857 5.71429C15.2857 5.4375 15.5089 5.21429 15.7857 5.21429Z"
          fill="#898A8C"
        />
      </g>
      <defs>
        <clipPath id="clip0_2024_24330">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  [AdFormats.Video]: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#clip0_2024_24344)">
        <path
          d="M6.75355 10.9578L10.3143 8.15956C10.3381 8.14067 10.3573 8.11664 10.3705 8.08928C10.3837 8.06191 10.3906 8.03192 10.3906 8.00153C10.3906 7.97114 10.3837 7.94114 10.3705 7.91378C10.3573 7.88641 10.3381 7.86239 10.3143 7.84349L6.75355 5.04349C6.6214 4.93992 6.42676 5.03278 6.42676 5.20064V10.7989C6.42676 10.9667 6.6214 11.0613 6.75355 10.9578Z"
          fill="#898A8C"
        />
        <path
          d="M14.5698 0.859314H1.4269C1.11083 0.859314 0.855469 1.11467 0.855469 1.43074V14.5736C0.855469 14.8897 1.11083 15.145 1.4269 15.145H14.5698C14.8858 15.145 15.1412 14.8897 15.1412 14.5736V1.43074C15.1412 1.11467 14.8858 0.859314 14.5698 0.859314ZM13.8555 13.8593H2.14118V2.14503H13.8555V13.8593Z"
          fill="#898A8C"
        />
      </g>
      <defs>
        <clipPath id="clip0_2024_24344">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  [AdFormats.ResponsiveDisplay]: (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <rect
        x="1"
        y="2"
        width="10"
        height="7"
        rx="0.75"
        stroke="#898A8C"
        strokeWidth="1"
        fill="none"
      />
      <rect
        x="9"
        y="6"
        width="6"
        height="8.5"
        rx="0.75"
        stroke="#898A8C"
        strokeWidth="1"
        fill="none"
      />
      <rect x="3" y="4" width="3" height="2" rx="0.3" fill="#898A8C" opacity="0.5" />
      <rect x="10.5" y="8" width="3" height="2" rx="0.3" fill="#898A8C" opacity="0.5" />
      <rect x="10.5" y="11" width="3" height="0.75" rx="0.375" fill="#898A8C" opacity="0.4" />
      <rect x="10.5" y="12.25" width="2" height="0.75" rx="0.375" fill="#898A8C" opacity="0.4" />
    </svg>
  ),
};

export const CAMPAIGN_EDITOR_SIDEBAR_LIST = [
  {
    id: 'campaign-settings',
    label: 'Campaign settings',
    isWithChildren: true,
    isWithArrow: false,
    isForceOpen: true,
    children: [],
  },
];

export const MAX_UPDATED_SECTIONS_COUNT = 10;

export enum OptionIds {
  BackgroundComponent = 'BackgroundComponent',
  BackgroundColorComponent = 'BackgroundColorComponent',
  BackgroundImageComponent = 'BackgroundImageComponent',
  ImageComponent = 'ImageComponent',
  ImagesComponent = 'ImagesComponent',
  VideoComponent = 'VideoComponent',
  PdfComponent = 'PdfComponent',
  ButtonComponent = 'ButtonComponent',
  TextComponent = 'TextComponent',
  IconsComponent = 'IconsComponent',
  CardsComponent = 'CardsComponent',
  PlayButtonComponent = 'PlayButtonComponent',
  CornerImagesComponent = 'CornerImagesComponent',
  CornerImageComponent = 'CornerImageComponent',
  FullBackgroundImageComponent = 'FullBackgroundImageComponent',
  ButtonsComponent = 'ButtonsComponent',
  MeetingEmbedComponent = 'MeetingEmbedComponent',
  CustomHtmlComponent = 'CustomHtmlComponent',
}

export const getBannerTypeIcon = (
  size: { width: number; height: number },
  iconSize: 16 | 48 = 48,
): ReactNode => {
  const ratio = size.height ? size.width / size.height : 1;
  const isSquare = Math.abs(ratio - 1) < 0.1;

  if (iconSize === 16) {
    const maxW = 12;
    const maxH = 10;
    const w = isSquare ? maxH : maxW;
    const h = isSquare ? maxH : Math.round(maxW / ratio);
    const x = (16 - w) / 2;
    const y = (16 - h) / 2;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <rect
          x={x + 0.5}
          y={y + 0.5}
          width={w - 1}
          height={h - 1}
          rx="0.75"
          stroke="#898A8C"
          strokeWidth="1"
          fill="none"
        />
        <rect x={x + 2} y={y + 2} width={w * 0.35} height={h * 0.4} rx="0.5" fill="#898A8C" />
        <rect
          x={x + w * 0.55}
          y={y + 2}
          width={w * 0.35}
          height={1}
          rx="0.5"
          fill="#898A8C"
          opacity="0.6"
        />
        <rect
          x={x + w * 0.55}
          y={y + 4}
          width={w * 0.35}
          height={1}
          rx="0.5"
          fill="#898A8C"
          opacity="0.4"
        />
        <text
          x={x + w / 2}
          y={y + h - 1.5}
          textAnchor="middle"
          fill="#898A8C"
          fontSize="3"
          fontFamily="sans-serif"
        >
          {size.width}x{size.height}
        </text>
      </svg>
    );
  }

  const maxW = 38;
  const maxH = 34;
  const w = isSquare ? maxH : maxW;
  const h = isSquare ? maxH : Math.round(maxW / ratio);
  const x = (48 - w) / 2;
  const y = (48 - h) / 2;

  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x={x + 0.5}
        y={y + 0.5}
        width={w - 1}
        height={h - 1}
        rx="2"
        stroke="currentColor"
        fill="none"
      />
      <rect
        x={x + 3}
        y={y + 3}
        width={w * 0.38}
        height={h * 0.4}
        rx="1.5"
        fill="currentColor"
        opacity="0.3"
      />
      <rect
        x={x + w * 0.55}
        y={y + 3}
        width={w * 0.35}
        height={2}
        rx="1"
        fill="currentColor"
        opacity="0.5"
      />
      <rect
        x={x + w * 0.55}
        y={y + 7}
        width={w * 0.35}
        height={2}
        rx="1"
        fill="currentColor"
        opacity="0.3"
      />
      <text
        x={x + w / 2}
        y={y + h - 3}
        textAnchor="middle"
        fill="currentColor"
        fontSize="7"
        fontFamily="sans-serif"
        opacity="0.5"
      >
        {size.width}x{size.height}
      </text>
    </svg>
  );
};

export const creativeTypesIcons: Record<string, ReactNode> = {
  [AdFormats.SingleImage]: (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M43.8031 8.07188H4.20312C3.25043 8.07188 2.47813 8.84418 2.47813 9.79687V38.1969C2.47813 39.1496 3.25043 39.9219 4.20312 39.9219H43.8031C44.7558 39.9219 45.5281 39.1496 45.5281 38.1969V9.79688C45.5281 8.84418 44.7558 8.07188 43.8031 8.07188ZM4.20312 6.79688C2.54627 6.79688 1.20312 8.14002 1.20312 9.79687V38.1969C1.20312 39.8537 2.54627 41.1969 4.20312 41.1969H43.8031C45.46 41.1969 46.8031 39.8537 46.8031 38.1969V9.79688C46.8031 8.14002 45.46 6.79688 43.8031 6.79688H4.20312Z"
        fill="currentColor"
      />
      <g clip-path="url(#clip0_2219_14297)">
        <circle cx="26" cy="17" r="1" stroke="currentColor" />
        <path
          d="M19 20.0377L19.9219 19.281C20.4015 18.8873 21.1244 18.9099 21.575 19.3326L23.8327 21.4505C24.1944 21.7898 24.7638 21.8361 25.1823 21.5602L25.3393 21.4567C25.9415 21.0597 26.7563 21.1057 27.3034 21.5676L29 23"
          stroke="currentColor"
          stroke-linecap="round"
        />
        <rect x="18.5" y="13.5" width="11" height="11" rx="1.5" stroke="currentColor" />
      </g>
      <rect opacity="0.4" x="10" y="28" width="28" height="1.5" rx="0.75" fill="currentColor" />
      <rect opacity="0.4" x="10" y="31.5" width="28" height="1.5" rx="0.75" fill="currentColor" />
      <rect opacity="0.4" x="13" y="35" width="22" height="1.5" rx="0.75" fill="currentColor" />
      <defs>
        <clipPath id="clip0_2219_14297">
          <rect width="12" height="12" fill="white" transform="translate(18 13)" />
        </clipPath>
      </defs>
    </svg>
  ),
  [AdFormats.Carousel]: (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2219_8206)">
        <g clip-path="url(#clip1_2219_8206)">
          <circle cx="26" cy="17" r="1" stroke="currentColor" />
          <path
            d="M19 20.0377L19.9219 19.281C20.4015 18.8873 21.1244 18.9099 21.575 19.3326L23.8327 21.4505C24.1944 21.7898 24.7638 21.8361 25.1823 21.5602L25.3393 21.4567C25.9415 21.0597 26.7563 21.1057 27.3034 21.5676L29 23"
            stroke="currentColor"
            stroke-linecap="round"
          />
          <rect x="18.5" y="13.5" width="11" height="11" rx="1.5" stroke="currentColor" />
        </g>
        <g clip-path="url(#clip2_2219_8206)">
          <path
            d="M47 20.0377L47.9219 19.281C48.4015 18.8873 49.1244 18.9099 49.575 19.3326L51.8327 21.4505C52.1944 21.7898 52.7638 21.8361 53.1823 21.5602L53.3393 21.4567C53.9415 21.0597 54.7563 21.1057 55.3034 21.5676L57 23"
            stroke="currentColor"
            stroke-linecap="round"
          />
          <rect x="46.5" y="13.5" width="11" height="11" rx="1.5" stroke="currentColor" />
        </g>
        <g clip-path="url(#clip3_2219_8206)">
          <path
            d="M-9 20.0377L-8.07811 19.281C-7.5985 18.8873 -6.87564 18.9099 -6.42501 19.3326L-4.16726 21.4505C-3.80556 21.7898 -3.23619 21.8361 -2.81768 21.5602L-2.66074 21.4567C-2.05851 21.0597 -1.24372 21.1057 -0.696595 21.5676L1 23"
            stroke="currentColor"
            stroke-linecap="round"
          />
          <rect x="-9.5" y="13.5" width="11" height="11" rx="1.5" stroke="currentColor" />
        </g>
        <rect opacity="0.4" x="17" y="27" width="14" height="1" rx="0.5" fill="currentColor" />
        <rect opacity="0.4" x="45" y="27" width="14" height="1" rx="0.5" fill="currentColor" />
        <rect opacity="0.4" x="-11" y="27" width="14" height="1" rx="0.5" fill="currentColor" />
        <rect opacity="0.4" x="17" y="29" width="14" height="1" rx="0.5" fill="currentColor" />
        <rect opacity="0.4" x="45" y="29" width="14" height="1" rx="0.5" fill="currentColor" />
        <rect opacity="0.4" x="-11" y="29" width="14" height="1" rx="0.5" fill="currentColor" />
        <rect opacity="0.4" x="19" y="31" width="10" height="1" rx="0.5" fill="currentColor" />
        <rect opacity="0.4" x="47" y="31" width="10" height="1" rx="0.5" fill="currentColor" />
        <rect opacity="0.4" x="-9" y="31" width="10" height="1" rx="0.5" fill="currentColor" />
        <rect x="11.5" y="7.5" width="25" height="33" rx="1.5" stroke="currentColor" />
        <rect x="39.5" y="7.5" width="25" height="33" rx="1.5" stroke="currentColor" />
        <rect x="-16.5" y="7.5" width="25" height="33" rx="1.5" stroke="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_2219_8206">
          <rect width="48" height="48" rx="4.5" fill="white" />
        </clipPath>
        <clipPath id="clip1_2219_8206">
          <rect width="12" height="12" fill="white" transform="translate(18 13)" />
        </clipPath>
        <clipPath id="clip2_2219_8206">
          <rect width="12" height="12" fill="white" transform="translate(46 13)" />
        </clipPath>
        <clipPath id="clip3_2219_8206">
          <rect width="12" height="12" fill="white" transform="translate(-10 13)" />
        </clipPath>
      </defs>
    </svg>
  ),
  [AdFormats.Video]: (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M43.8031 8.07188H4.20312C3.25043 8.07188 2.47813 8.84418 2.47813 9.79687V38.1969C2.47813 39.1496 3.25043 39.9219 4.20312 39.9219H43.8031C44.7558 39.9219 45.5281 39.1496 45.5281 38.1969V9.79688C45.5281 8.84418 44.7558 8.07188 43.8031 8.07188ZM4.20312 6.79688C2.54627 6.79688 1.20312 8.14002 1.20312 9.79687V38.1969C1.20312 39.8537 2.54627 41.1969 4.20312 41.1969H43.8031C45.46 41.1969 46.8031 39.8537 46.8031 38.1969V9.79688C46.8031 8.14002 45.46 6.79688 43.8031 6.79688H4.20312Z"
        fill="currentColor"
      />
      <path
        d="M19.6709 17.6611L30.0518 23.502L19.6709 29.3398C19.668 29.3414 19.6609 29.3415 19.6504 29.3438V17.6562L19.6709 17.6611Z"
        stroke="currentColor"
        stroke-width="1.3"
      />
    </svg>
  ),
  [AdFormats.ResponsiveDisplay]: (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2.5" y="7.5" width="30" height="21" rx="2" stroke="currentColor" fill="none" />
      <rect x="26.5" y="18.5" width="19" height="25" rx="2" stroke="currentColor" fill="none" />
      <rect x="6" y="11" width="10" height="7" rx="1" fill="currentColor" opacity="0.3" />
      <rect x="18" y="11" width="11" height="2" rx="1" fill="currentColor" opacity="0.4" />
      <rect x="18" y="14.5" width="11" height="1.5" rx="0.75" fill="currentColor" opacity="0.3" />
      <rect x="6" y="20" width="21" height="1.5" rx="0.75" fill="currentColor" opacity="0.3" />
      <rect x="6" y="23" width="14" height="1.5" rx="0.75" fill="currentColor" opacity="0.3" />
      <rect x="30" y="22" width="12" height="8" rx="1" fill="currentColor" opacity="0.3" />
      <rect x="30" y="32" width="12" height="1.5" rx="0.75" fill="currentColor" opacity="0.4" />
      <rect x="30" y="35" width="12" height="1.5" rx="0.75" fill="currentColor" opacity="0.3" />
      <rect x="30" y="38" width="8" height="1.5" rx="0.75" fill="currentColor" opacity="0.3" />
    </svg>
  ),
};
